module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp1_7016.e64e0e19.png";